enum AuthErrorCodes {
    BLOCKED_USER = "BLOCKED_USER",
    EMAIL_ALREADY_VERIFIED = "EMAIL_ALREADY_VERIFIED",
    EMAIL_NOT_VERIFIED = "EMAIL_NOT_VERIFIED",
    DOCUMENT_MISMATCH = "DOCUMENT_MISMATCH",
    INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
    INVALID_EMAIL_ADDRESS = "INVALID_EMAIL_ADDRESS",
    INVALID_EMAIL_VERIFICATION_CODE = "INVALID_EMAIL_VERIFICATION_CODE",
    INVALID_PASSWORD = "INVALID_PASSWORD", // skipcq: SCT-A000
    INVALID_PASSWORD_CODE = "INVALID_PASSWORD_CODE",
    PASSWORD_ALREADY_USED = "PASSWORD_ALREADY_USED",
    RECOVER_PASSWORD_ERROR = "RECOVER_PASSWORD_ERROR",
    RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR",
    SESSION_EXPIRED = "SESSION_EXPIRED",
    TOKEN_ALREADY_VERIFIED = "TOKEN_ALREADY_VERIFIED",
    TOKEN_EXPIRED = "TOKEN_EXPIRED",
    TOKEN_NOT_FOUND = "TOKEN_NOT_FOUND",
    USER_NOT_FOUND = "USER_NOT_FOUND",
    USER_NOT_VERIFIED = "USER_NOT_VERIFIED",
    VERIFICATION_EMAIL_COULD_NOT_BE_RESENT = "VERIFICATION_EMAIL_COULD_NOT_BE_RESENT",
    EMAIL_ADDED = "EMAIL_ADDED",
    USER_NOT_MIGRATED_TO_COGNITO = "USER_NOT_MIGRATED_TO_COGNITO"
}

export default AuthErrorCodes;
